import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import BlogCards from '../../components/blogs/Blogs';
import FaqSection from '../../components/about/FAQ';
import { useSelector } from 'react-redux';

// Translation dictionary
const translations = {
  gb: { // English
    title: "Blog",
    subtitle: "",
    description: "",
    buttonText: "Get in Touch"
  },
  sa: { // Arabic
    title: "المدونة",
    subtitle: "",
    description: "",
    buttonText: "تواصل معنا"
  },
  fr: { // French
    title: "Blog",
    subtitle: "",
    description: "",
    buttonText: "Contactez-nous"
  },
  de: { // German
    title: "Blog",
    subtitle: "",
    description: "",
    buttonText: "Kontakt aufnehmen"
  }
};

const Blog = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb; // Default to English if language not found

  const heroContent = {
    title: t.title,
    subtitle: t.subtitle,
    description: t.description,
    buttonText: t.buttonText
  };

  return (
    <>
      <section
        className="equipment-rental-hero"
        style={{
          background: 'radial-gradient(circle, #ffffff 0%, #f8d4d4 100%)'
        }}>
        <div className="container h-100">
          <div className="row justify-content-center align-items-center text-center h-100">
            <div className="col-md-8">
              <h1 className="mb-3 mt-3">{heroContent.title}</h1>
              <h3 className="mb-4" style={{ color: '#EF4444' }}>
                {heroContent.subtitle}
              </h3>
              <p className="mb-4" style={{ color: '#000' }}>
                {heroContent.description}
              </p>
              <Link
                to="/contact"
                className="btn btn-primary mt-3 mb-5"
                style={{
                  backgroundColor: '#B91C1C',
                  borderRadius: '50px',
                  color: 'white',
                  padding: '10px 30px',
                  border: '0',
                  textDecoration: 'none' // Remove underline from link
                }}
              >
                {heroContent.buttonText} <FaArrowRight className="ms-2" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <BlogCards />

      <FaqSection />
    </>
  );
};

export default Blog;